<template>
  <div>
    <BCard no-body class="mb-0" >
      <div class="m-2">
        <BRow>

          <!-- Per Page -->
          <BCol cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0" >
            <label>{{$t('Show')}}</label>
            <vSelect v-model="perPage" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="perPageOptions" :clearable="false" class="per-page-selector d-inline-block mx-50" />
            <label>{{$t('entries')}}</label>
          </BCol>

          <!-- Search -->
          <BCol cols="12" md="6" >
            <div class="d-flex align-items-center justify-content-between">
              <!-- <BFormInput v-model="searchQuery" class="d-inline-block mr-1" :placeholder="$t('Search') + '...'" /> -->
              <TextInputValidated :vsModel.sync="searchQuery" :vsCols="false" vsPlaceholder="Buscar ..." class="d-inline-block mr-1" />
              <BButton variant="primary" @click="showListGroup=false; showAddGroup=true" v-if="ability.can('create', 'group')">
                <span class="text-nowrap">{{$t('Add Group')}}</span>
              </BButton>
            </div>
          </BCol>
        </BRow>

      </div>

      <BTable ref="refGroupListTable" class="position-relative" :items="fetchGroups" responsive :fields="tableColumns" primary-key="id" :sort-by.sync="sortBy" show-empty :empty-text="$t('No matching records found')" :sort-desc.sync="isSortDirDesc" >

        <!-- Column: Group -->
        <template #cell(group)="data">
          <BMedia vertical-align="center">
            <template #aside>
              <BAvatar size="40" :src="data.item.avatar" :text="avatarText(data.item.name)" :to="{ name: 'groups-view', params: { id: data.item.id } }" />
            </template>
            <BLink @click="selectedGroupId=data.item.id; showListGroup=false; showViewGroup=true;" class="font-weight-bold d-block text-nowrap" > {{ data.item.name }} </BLink>
            <small class="text-muted" v-if="data.item.email">{{ data.item.email }}</small>
          </BMedia>
        </template>
        
        <!-- Column: Serie -->
        <template #cell(series)="data">
          <span><small>{{ data.item.invoice_serie }} (Facturas)</small></span><br>
          <span><small>{{ data.item.corrective_invoice_serie }} (Facturas rectificativas)</small></span><br>
          <span><small>{{ data.item.ticket_serie }} (Recibos)</small></span><br>
          <span><small>{{ data.item.corrective_ticket_serie }} (Recibos rectificativos)</small></span><br>
          <span><small>{{ data.item.expense_serie }} (Gastos)</small></span>

        </template>

        <!-- Column: Status -->
        <template #cell(status)="data">
          <BBadge pill :variant="`light-${resolveGroupStatusVariant(data.item.status)}`" class="text-capitalize" v-if="data.item.status == true"> {{$t('Active')}} </BBadge>
          <BBadge pill :variant="`light-${resolveGroupStatusVariant(data.item.status)}`" class="text-capitalize" v-else> {{$t('Inactive')}} </BBadge>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <BDropdown variant="link" no-caret :right="$store.state.appConfig.isRTL" >

            <template #button-content>
              <FeatherIcon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
            </template>
            <BDropdownItem @click="selectedGroupId=data.item.id; showListGroup=false; showViewGroup=true;" v-if="ability.can('read', 'group')">
              <FeatherIcon icon="FileTextIcon" />
              <span class="align-middle ml-50">{{$t('Details')}}</span>
            </BDropdownItem>

            <BDropdownItem @click="selectedGroupId=data.item.id; showListGroup=false; showEditGroup=true;" v-if="ability.can('write', 'group')">
              <FeatherIcon icon="EditIcon" />
              <span class="align-middle ml-50">{{$t('Edit')}}</span>
            </BDropdownItem>

            <BDropdownItem @click="deletePopupAxios(data.item.id, `groups/${data.item.id}`)" v-if="ability.can('delete', 'group')">
              <FeatherIcon icon="TrashIcon" />
              <span class="align-middle ml-50">{{$t('Delete')}}</span>
            </BDropdownItem>
          </BDropdown>
        </template>

      </BTable>

      <div class="mx-2 mb-2">
        <BRow>

          <BCol cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start" >
            <span class="text-muted">{{$t('Showing')}} {{ dataMeta.from }} {{$t('to')}} {{ dataMeta.to }} {{$t('of')}} {{ dataMeta.of }} {{$t('entries')}}</span>
          </BCol>

          <!-- Pagination -->
          <BCol cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end" >
            <BPagination v-model="currentPage" :total-rows="totalGroups" :per-page="perPage" first-number last-number class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item" >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </BPagination>
          </BCol>
        </BRow>
      </div>

    </BCard>
  </div>

</template>

<script>
import { BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BBadge, BDropdown, BDropdownItem, BPagination,} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted, inject } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import useGroupsList from './useGroupsList'
import groupsStoreModule from '../groupsStoreModule'
import GroupsListFilters from './GroupsListFilters.vue'
import ability from '@/libs/acl/ability'
import i18n from '@/libs/i18n'
import popups from '@/hooks/popups'
import TextInputValidated from '@/components/forms/TextInputValidated.vue'

export default {
  components: { GroupsListFilters, BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BBadge, BDropdown, BDropdownItem, BPagination, vSelect, TextInputValidated },
  setup() {

    // REGISTER / UNREGISTER MODULE
    const GROUPS_APP_STORE_MODULE_NAME = 'groups'
    if (!store.hasModule(GROUPS_APP_STORE_MODULE_NAME)) store.registerModule(GROUPS_APP_STORE_MODULE_NAME, groupsStoreModule)
    onUnmounted(() => { if (store.hasModule(GROUPS_APP_STORE_MODULE_NAME)) store.unregisterModule(GROUPS_APP_STORE_MODULE_NAME) })

    const statusOptions = [
      { label: i18n.t('Active'), value: true },
      { label: i18n.t('Inactive'), value: false },
    ]
    const {
      fetchGroups,
      tableColumns,
      perPage,
      currentPage,
      totalGroups,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refGroupListTable,
      refetchData,
      resolveGroupStatusVariant,
      statusFilter,
    } = useGroupsList()

    const showAddGroup = inject('showAddGroup')
    const showListGroup = inject('showListGroup')
    const showEditGroup = inject('showEditGroup')
    const showViewGroup = inject('showViewGroup')
    const selectedGroupId = inject('selectedGroupId')

    const { deletePopupAxios } = popups()

    return {
      fetchGroups,
      tableColumns,
      perPage,
      currentPage,
      totalGroups,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refGroupListTable,
      refetchData,
      avatarText,
      resolveGroupStatusVariant,
      statusFilter,
      statusOptions,
      ability,
      deletePopupAxios,
      showAddGroup, 
      showListGroup,
      showEditGroup,
      showViewGroup,
      selectedGroupId
    }
  },
}
</script>

<style lang="scss" scoped>
  .per-page-selector {
    width: 90px;
  }
</style>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-select.scss';
</style>
